module.exports = __webpack_public_path__ + "static/media/071-computer.d6787fa2.svg";